import React, { useState } from "react";
import "./ContactUs.css";
import { useForm } from "react-hook-form";
import { Form, Alert } from "react-bootstrap";

const ContactUs = () => {
  const [msg, setMsg] = useState("");
  const [alertVariant, setAlertVariant] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await fetch("reactapi/api/codeinputs/contact_us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      setMsg("Thanks for your response, We will get back to you soon");
      setAlertVariant("success");
      setShowAlert(true);
      reset();
    } catch (error) {
      setMsg("Error: " + error.message);
      setAlertVariant("danger");
      setShowAlert(true);
    }
  };

  return (
    <section className="contact-theme-section">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Content */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <h2 className="contact-title">
              Let’s Build Something <br />
              <span>Great Together</span>
            </h2>

            <p className="contact-subtitle">
              Have a project in mind? Get in touch with Code Inputs and let’s
              create smart digital solutions for your business.
            </p>

            <ul className="contact-info list-unstyled">
              <li><i className="fas fa-envelope"></i> codeinputs@gmail.com</li>
              <li><i className="fas fa-phone"></i> +91 7693890243</li>
              <li><i className="fas fa-globe"></i> www.codeinputs.com</li>
            </ul>

            <div className="social-links mt-4">
              <a href="https://www.instagram.com/codeinputs_24/" className="social-icon"><i className="fab fa-instagram"></i></a>
              <a href="https://www.facebook.com/profile.php?id=61563461764043" className="social-icon"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.youtube.com/@CodeInputs" className="social-icon"><i className="fab fa-youtube"></i></a>
              <a href="https://in.pinterest.com/codeinputs/" className="social-icon"><i className="fab fa-pinterest"></i></a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-7">
            <div className="contact-form-card">

              {showAlert && (
                <Alert
                  variant={alertVariant}
                  dismissible
                  onClose={() => setShowAlert(false)}
                >
                  {msg}
                </Alert>
              )}

              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Full Name"
                      {...register("name", { required: "Full Name is required" })}
                    />
                    {errors.name && (
                      <p className="text-danger">{errors.name.message}</p>
                    )}
                  </div>

                  {/* Email */}
                  <div className="col-md-6 mb-3">
                    <Form.Control
                      type="email"
                      placeholder="Email Address"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Please enter a valid email address"
                        }
                      })}
                    />
                    {errors.email && (
                      <p className="text-danger">{errors.email.message}</p>
                    )}
                  </div>

                </div>

                {/* Subject */}
                <div className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Subject"
                    {...register("subject", {
                      required: "Subject is required",
                      minLength: {
                        value: 5,
                        message: "Subject must be at least 5 characters"
                      }
                    })}
                  />
                  {errors.subject && (
                    <p className="text-danger">{errors.subject.message}</p>
                  )}
                </div>

                  {/* Message */}
                  <div className="mb-4">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Your Message"
                      {...register("message", {
                        required: "Message is required",
                        minLength: {
                          value: 10,
                          message: "Message must be at least 10 characters"
                        }
                      })}
                    />
                    {errors.message && (
                      <p className="text-danger">{errors.message.message}</p>
                    )}
                  </div>

                <button type="submit" className="btn contact-btn">
                  Send Message
                </button>
              </Form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactUs;
